// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"826":"7b991aba","3150":"3c64335d","7101":"f3caaee4","7835":"ba4b2486","8749":"4137b440"}[chunkId] + ".chunk.css";
};